var Navigator = function (id) {
  this.elStatus = $('.nav-section');
  this.elNav = $('.nav-list');
  this.elChapter= $('.nav-active');
  // this.items = this.el.find('.nav-item');
};
var navTL = new TimelineLite({paused: true});

$(document).ready(function() {
  // Open&Close navigation overlay.
  var $navItem = $('.nav-overlay').find('.nav-list').find('li');
  var $navOverlay = $('.nav-overlay').find('.overlay');
  var $aSlowMo = CustomEase.create("custom", "M0,0 C0,0 0.123,0.787 0.236,0.844 0.452,0.952 1,1 1,1");


  navTL.to($('.nav-overlay'), 0.2, { opacity: 1, ease: Power4.easeOut })
  .from($navOverlay, 1, { opacity: 1, scaleY: 0, transformOrigin: "center bottom", ease: Power4.easeInOut })
  .staggerFrom($navItem, 0.5, { opacity: 0, yPercent: 100, ease: $aSlowMo }, 0.1, 0.8);
});

// Add item.
Navigator.prototype.addItem = function (sectionId, title, chapter) {
  this.elStatus.append('<li class="nav-item" data-section="' + sectionId + '"><span class="nav-item-content">' + title + '</span></li>');
  this.elNav.append('<li class="nav-item" data-section="' + sectionId + '"><a href="#" data-section="' + sectionId + '" data-title="' + title + '"><span class="nav-item-content">' + title + '</span></a></li>');
  this.elChapter.append('<li class="nav-item" data-section="' + sectionId + '">' + chapter + '</li>');

};
// Close menu.
Navigator.prototype.closeMenu = function () {
  $('.open-nav, .nav-overlay').removeClass('active');
  navTL.reverse().timeScale(2);
};
// Open menu.
Navigator.prototype.openMenu = function () {
  $('.open-nav, .nav-overlay').addClass('active');
  navTL.play().timeScale(1);
};
// Navigate to section.
Navigator.prototype.navigate = function (elem) {
  var $this = $(elem);
  var target = $this.data('section');
  var posY = $('.section[data-section="' + target + '"]').position().top;
  app.nav.closeMenu();
  TweenLite.to(window, 1, { scrollTo: { y: posY }, ease:Power2.easeInOut});
};